import { rankWith, isBooleanControl } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { RadioSelect } from '../../../../../controls/RadioSelect';
import { FormItem } from '../../../../../controls/FormItem';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';
import { useDynamicFormContext } from '../../../DynamicFormContext';

const BooleanControl = ({
  path,
  label,
  schema,
  data,
  handleChange,
  handleBlur,
  required,
  uischema,
  disabled,
  optionalMessage,
}: FieldProps) => {
  const moreInfo = uischema.options?.moreInfo;
  const {handleMutateChanges} = useDynamicFormContext()

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-boolean-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <div>
        <RadioSelect
          name={path}
          value={data}
          onBlur={() => handleBlur(path)}
          onChange={(value) => {
            handleChange(path, value)
            handleMutateChanges([{path, value}])
            
            }
          }
          options={[
            { name: 'Yes', value: true },
            { name: 'No', value: false },
          ]}
          disabled={disabled}
        />
        {schema.description && (
          <p className="description">{schema.description}</p>
        )}
      </div>
    </FormItem>
  );
};

export const BooleanInputControlEntry = {
  tester: rankWith(3, isBooleanControl),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(BooleanControl)),
};
